"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSchema = exports.SearchResultSchema = void 0;
const zod_1 = require("zod");
const gender_1 = require("./gender");
exports.SearchResultSchema = zod_1.z.object({
    type: zod_1.z.literal('team').or(zod_1.z.literal('player')),
    age: zod_1.z.number().nullable(),
    id: zod_1.z.number(),
    name: zod_1.z.string(),
    nickname: zod_1.z.string().nullable(),
    code: zod_1.z.string(),
    gender: gender_1.GenderSchema,
});
exports.SearchSchema = zod_1.z.object({
    player: zod_1.z.array(exports.SearchResultSchema),
    team: zod_1.z.array(exports.SearchResultSchema),
});
//# sourceMappingURL=search.js.map